var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingShow),expression:"loadingShow"}],staticClass:"jgz-load"},[_c('div',{staticClass:"jgz-load-img"})])}
var staticRenderFns = []

export { render, staticRenderFns }